export const JOB_STATE_DRAFT = 'draft';
export const JOB_STATE_PROCESSING = 'processing';
export const JOB_STATE_COMPLETE = 'completed';
export const JOB_STATE_FAILED = 'failed';
export const JOB_STATE_INCOMPLETE = 'incomplete';